<style>
.coords {
	position: absolute;
	bottom: 100px;
	left: 5px;
	font-weight: 600;
	font-size: 12px;
	color: white;
	min-width:220px;
	text-align: left;
	background-color: #2d39536c;
	z-index: 1;
	padding:5px 10px;
	border-radius: 3px;
	line-height:20px;
}
</style>

<div id="measure-map-controls" class="pane coords">
	<p>Add point (at end): ctrl/cmd click</p>
	<p>Add point (on line): alt click</p>
	<p>Remove point: right click</p>
	<p>Clear all: use side menu</p>
</div>

<script>
	import { onMount } from "svelte";

	onMount(() => {
		var element =  document.querySelector("#measure-map-controls");
		document.querySelector("#map-overlay").appendChild(element);
	});

</script>


